/**
 * @file utils/localStorage.js
 * @description Utility functions for saving and loading Redux state from session storage.
 *              Used for persisting state across page reloads within a session.
 * @author govind dindewad
 * @date 13 May 2025
 */

/**
 * @function saveState
 * @description Saves the Redux state to sessionStorage under the key 'reduxState'.
 * @param {Object} state - The Redux state to be saved.
 */
export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem('reduxState', serializedState);
    } catch (e) {
        console.warn('Could not save state', e);
    }
};

/**
 * @function loadState
 * @description Loads and parses the Redux state from sessionStorage.
 * @returns {Object|undefined} - The parsed Redux state object or undefined if not found or an error occurs.
 */
export const loadState = () => {
    try {
        const serializedState = sessionStorage.getItem('reduxState');
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (e) {
        console.warn('Could not load state', e);
        return undefined;
    }
};
